import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-po',
  templateUrl: './po.component.html',
  styleUrls: ['./po.component.css']
})
export class PoComponent implements OnInit {
    poKeyno;

    public edit?: Edit;

    public selectListPoStatuses: PoStatusItem[] = [];

    public grid?: GridOptions;

    public saving = false;

    public deleting = false;

    public pohKeynoTopButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'poh', gotoParms: () => this.edit!.poh_keyno_top ?? '' }];

    public prodIdButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.edit!.prod_keyno ?? '' }];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.poKeyno = this.stateService.getStateParams()['po_keyno'];
    }

    private async loadEdit() {
        if (!!this.poKeyno) {
            this.edit = (await this.datatask.Post(1352, { po_keyno: this.poKeyno }))[0];
        }
    }

    private async loadPoStatuses() {
        this.selectListPoStatuses = await this.datatask.Post(2002);
    }

    private loadGrid() {
        if (!!this.edit) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.edit.view_id)
                    .setLoadDataFunction({
                        method: this.edit.p2_datatask_keyno,
                        parameters: () => this.edit
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2444, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1926, { po_keyno: this.edit.po_keyno }))[0];

                    if (response?.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadPoStatuses();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    poh_keyno_top: string;
    po_keyno: string;
    prod_id: string;
    prod_name_long: string;
    quantity: string;
    postatus_no: string;
    lastdt_finish: string;
    stock_keyno: string;
    view_id: string;
    p2_datatask_keyno: number;
    quantity_finished: string;
    prod_keyno: string;
    show_goto_product: string;
}

interface PoStatusItem {
    postatus_no: string;
    postatus_name: string;
}
